import React, { FC, useContext } from 'react';
import get from 'lodash/get';
import styled from 'styled-components';

import Checkbox from 'src/presentation/components/forms/Checkbox';
import FormContext from 'src/presentation/contexts/FormContext';
import InformationIcon from '@ad-scripts/presentation/components/common/icons/fill/information-fill';
import TextareaField from 'src/presentation/components/forms/TextareaField';
import { OptionSection, StyledSectionContainer } from '../shared/EditorSectionLayout';
import { Tooltip } from 'src/presentation/components/agent_desktop_components';
import { CHAT_BRAND } from 'src/constants/branding';

const ChatCampaignActions: FC<any> = ({ attr, 'data-aid': dataAid }) => {
  const { workingState } = useContext(FormContext);
  const item = get(workingState, `${attr}[0]`);

  return (
    <OptionSection data-aid={dataAid} title="Actions" isError={false}>
      <ChatCampaignActionItem key={get(item, 'id')} attr={`${attr}[0]`} />
    </OptionSection>
  );
};

const InformationIconWithTooltip = ({ infoText }) => (
  <Tooltip
    data-aid="column-tooltip"
    message={<TooltipMessage data-aid="column-tooltip-text">{infoText}</TooltipMessage>}
  >
    <StyledInformationIcon />
  </Tooltip>
);

const CheckboxLabel = ({ label, infoText }) => {
  return (
    <div>
      <CheckboxLabelText>{label}</CheckboxLabelText>
      <CheckboxLabelInfo>
        <InformationIconWithTooltip infoText={infoText} />
      </CheckboxLabelInfo>
    </div>
  );
};

const ChatCampaignActionItem: FC<any> = ({ attr }) => {
  return (
    <StyledSectionContainer>
      <SelectTypeContainer>
        <SelectTypeName>Then display greeting</SelectTypeName>
        <FillTheFlexArea></FillTheFlexArea>
      </SelectTypeContainer>
      <TextareaField
        attr={`${attr}.content.message`}
        data-aid={`${attr}-content-message`}
        description={`Displaying a proactive chat greeting will replace the first message
            that is setup in ${CHAT_BRAND.name}. If onboarding in enabled, the greeting will also
            replace the third message in ${CHAT_BRAND.name}.`}
        placeholder="Hi there! How can we help you today?"
      />
      <CheckboxesContainer>
        <Checkbox
          label={
            <CheckboxLabel
              label="Ignore Chat throttling"
              infoText={`Ignore the throttling threshold that is set in ${CHAT_BRAND.name}.`}
            />
          }
          attr={`${attr}.content.ignoreThrottling`}
          data-aid={`${attr}-content-ignoreThrottling`}
        />
        <Checkbox
          label={
            <CheckboxLabel
              label="Skip onboarding"
              infoText={
                <>
                  Customers will not be asked to enter their name
                  <br />
                  or email when they reply to this campaign.
                </>
              }
            />
          }
          attr={`${attr}.content.skipOnboarding`}
          data-aid={`${attr}-content-skipOnboarding`}
        />
      </CheckboxesContainer>
    </StyledSectionContainer>
  );
};

const CheckboxLabelText = styled.span``;
const CheckboxLabelInfo = styled.span`
  margin-left: 4px;
  position: relative;
  top: 3px;
`;

const CheckboxesContainer = styled.div`
  padding: 8px 0;

  & > label:nth-child(2) {
    margin-left: 40px;
  }
`;

const SelectTypeContainer = styled.div`
  padding-top: 8px;
  display: flex;
  align-items: center;
`;

const SelectTypeName = styled.span`
  margin-bottom: 2px;
`;

const TooltipMessage = styled.div`
  text-align: center;
  margin: 0;
  line-height: 162%;
`;

const StyledInformationIcon = styled(InformationIcon)`
  fill: ${p => p.theme.colors.gray600};
  height: 15px;
  width: 15px;
`;

const FillTheFlexArea = styled.div`
  margin: auto;
`;

export default ChatCampaignActions;
